import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Divider from '../components/Divider'
import CTAButton from '../components/CTAButton'
import Hero from '../components/Hero'
import CenterRow from '../components/CenterRow'
import Heading from '../components/Heading'
import AppsAndService from '../components/AppsAndService'
import LeadForm from '../components/LeadForm'

class AboutPage extends React.Component {
  render () {
  	const pages = [ ...this.props.route.pages ]
    const path = this.props.route.page.path

  	const meta = {
  		description: "We are the complete acoustic cleaner (sonic horn) supplier. With experience dating back to 1989, we can supply or design an acoustic cleaning system to suit your requirements. As a leader in the industry, our team takes your need seriously. From design to repair and everything in between, we simply blow your competition away.",
			keywords: "Acoustic Cleaning Systems",
  		headline: "ACS About: Our history sets us apart.",
  		title: "ACS About: Our history sets us apart."
  	}

    return (
      <div className="about-page">
        <Helmet
          title={`${meta.title}`}
          meta={[
            { name: "Description", content: `${meta.description}`},
            { name: "Keywords", content: `${meta.keywords}`},
            { property: "og:title", content: `${meta.headline}`},
            { property: "og:description", content: `${meta.description}`},
            { property: "og:type", content: "article"},
            { property: "og:url", content: `${config.rootUrl}${path}`},
            { name: "twitter:card", content: "summary_large_image"},
            { name: "twitter:site", content: `${config.twitterHandle}` },
            { name: "twitter:creator", content: `${config.twitterHandle}` },
            { name: "twitter:title", content: `${meta.title}` },
            { name: "twitter:description", content: `${meta.description}` }
          ]}
        />
				<Hero headline='Put Our Experience to Work for You.'
					className="applications"
					images={[
						'/images/hero/1.jpg',
						'/images/hero/2.jpg',
						'/images/hero/0.jpg',
					]}
				>
					<LeadForm />
				</Hero>
				<div className="container page installations-page">
					<br /><br />
					<CenterRow headline="We are the complete sonic horn supplier.">
						Acoustic Cleaning Systems, Inc.’s experience dates back to 1983 and the key personnel have
						over 70 years combined experience in the utility industry and the application of acoustic
						cleaners in a variety of applications. ACS can supply or design an acoustic cleaning system to
						suit your requirements. From design to repair and everything in between, we simply blow our
						competition away.
					</CenterRow>
					<Divider />
					<div className="row center-xs">
						<div className="col-md-8 left">
							<h2>Our Story</h2>
							<img className="right-img" src="/images/our-story.jpg" />
							<p>
								Acoustic Cleaning Systems, Inc. was started to be an affordable yet reliable supplier of acoustic
								cleaners to the marketplace. Company owner Paul Argo began his career at Drayton
								Corporation in 1989 when he was hired to promote the Drayton Corporation acoustic cleaner
								product line. The company’s primary focus was on combustion processes within the utility and
								pulp and paper industries. As the business grew, Paul got more involved with the day to
								operational side of the business.
							</p>
							<br />
							<p>
								In 1999, Drayton Corporations owners (Jeff and Jake Shelton) decided to sell the acoustic
								cleaner product line to BHA Group from Kansas City, MO. BHA contracted Drayton Corporation
								to continue manufacturing the acoustic cleaner product line for BHA. Paul was the main person
								responsible for handling the manufacturing of the acoustic cleaners required by BHA.
							</p>
							<br />
							<p>
								The following year (2000) what was remaining of Drayton Corporation was sold to Boiler Tube
								Co. of America (BTA). BTA honored the contract between Drayton and BHA and continued
								manufacturing the acoustic cleaners for BHA. In 2001 BTA made the decision to close the
								Jacksonville, AL operation.
							</p>
							<br />
							<p>
								In 2003, Paul decided to form his own acoustic cleaner business and that was the start of
								Acoustic Cleaning Systems, Inc. as we know it today. Since inception, Acoustic Cleaning
								Systems, Inc. has grown every year and is now the market leader for acoustic cleaners in the
								U.S.A. Since 2007, ACS has secured more SCR OEM projects in the U.S.A. than any other
								acoustic cleaner manufacturer and continues to support the acoustic cleaner spare parts
								business among U.S. customers as well as the international marketplace.
						 </p>
						 <br />
						 <br />
						 <h2>Key Personnel</h2>
						 <p>
							 Anthony Cofield- Anthony provides engineering and quality submittals for major OEM projects. He also generates CAD drawings, product literature, and website updates. He has over 10 years of experience with the ACS acoustic cleaner product line and 16 years of experience in CAD and
							 QC disciplines.
						 </p>
						 <br />
						 <p>
							 Jake Shelton- Jake joined the ACS team in April of 2016 and brought a wealth of knowledge and
							 experience to ACS in the application of acoustic cleaners in all applications. His knowledge of
							 the SCR business is invaluable.
						 </p>
						 <br />
						 <p>
							 Experience, integrity, innovation and application knowledge should make ACS the clear choice
							 when choosing an acoustic cleaner supplier. We offer the complete package whether total
							 acoustic cleaner systems, spare parts, or design solutions we are committed to being your
							 acoustic cleaner supplier. Please give us an opportunity to blow you away!
						 </p>
						 <br />
						 <br />
						 <h2>Milestone Event: September 2014 Introduction of the Magnum Acoustic Cleaner</h2>
						 <p>
								The Magnum acoustic cleaner was introduced in 2014 and has become the acoustic cleaner of
								choice for the U.S. SCR market as well as other large applications. The use of the Magnum has
								many benefits when compared to a standard 75hz of old. The bell is shorter and is much easier
								to insulate and lag into a reactor/application and since it can be insulated easier and more
								effectively it greatly reduces the possibility of buildup issues within the bell. Coupled with the
								fact that this acoustic cleaner is more powerful and can clean a larger area, clearly makes it the
								acoustic cleaner of choice.
					 		</p>
						</div>
					</div>
					<Divider />
					<Heading text="Check out some of our recent customers and their projects." />
					<div className="current-clients">
						<div className="row">
							<div className="col-md-3 col-xs-6">
								<p>
									B&W purchased (20) 75hz horns for <b>City Utilities of Springfield</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									B&W Consumers Energy purchased (8) 75hz horns for an SCR application at <b>Campbell St.</b>
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Midwesco Filter Resources</b> has an alliance with ACS, where ACS private labels horns for baghouse exclusivity. Midwesco has purchased well over $250,000.00 in sonic horns from ACS.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Dairyland Power Co-Op</b> purchased (4) 75hz for an economizer application burning 100% PRB coal at <b>JP Madgett</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									Dairyland Power Co-Op purchased (3) 75hz horns for an economizer application at <b>Genoa St</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									Enerfab purchased (32) 75hz horns for <b>Associated Electric Thomas Hill Energy Ctr</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Dayton Power & Light</b> purchased (9) 75hz horns for additional layers of catalyst.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									We Energies purchased (10) 75hz horns for additional layers of catalyst at <b>Pleasant Prairie</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Conectiv-Edgemoor</b> purchased (24) ESP-75 Horns to replace GE/BHA units on ESP applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									Airtek purchased replacement bell sections for numerous plant locations within <b>Dominion Va. Power and New Page Corporation</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									Clyde Bergemann purchased (16) 75hz horns for boiler applications and a Ljungstrom Air Heater at <b>Progress Energy-Robinson Station</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									Neundorfer purchased (16) ESP-75 horns for an ESP at <b>Texas Utility</b>
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Alliant Energy</b> purchased ACS horns for boiler applications at Prairie Creek.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Fueltech Korea</b> purchased over (60) ACS horns for various SCR applications in Korea.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Southern Illinois Power</b> has utilized ACS for repairs on 48+ horns on SCR and ESP applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Solutia</b> purchased ACS horns for heat exchanger applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Corning</b> purchased ACS horn for proprietary applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Dupont Red Lion</b> purchased ACS horns for boiler applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>St. Mary’s Cement</b> has purchased ACS horns for cement silos.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>AEP Cardinal</b> purchased (18) 75hz horns for additional layers of catalyst.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>St. Petersburg Russia</b> purchased 75hz and 230hz units for boiler applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>AEP Gavin</b> purchased (18) 75hz horns with commitment from AEP for units at <b>Mountaineer</b> along with Amos if they elect to add additional horns.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Dominion Mt. Storm</b> purchased (12) 75hz Units for additional layers of catalyst.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Cargill Salt</b> purchased horns for boiler applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Consumers Energy</b> purchased (16) horns for a tubular air heater and an economizer application at <b>Carnes Weadock St</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Medical Center Company</b> purchased (14) replacement sound generators for Drayton horns as well as (1) 230hz horn.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Pacificorp</b> purchased (3) 75hz horns for the <b>Jim Bridger Power St</b>. ESP application.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Dupont</b> purchased (4) 75hz and (3) 230hz horns for various applications.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Haverhill North Petroleum Company</b> (division on Sunoco) purchased (4) 75hz horns for a petroleum coke furnace.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Peco / FGC</b> purchased (6) 75hz horns for an ESP application at <b>Alliant Energy</b>.
								</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>
									<b>Core Metals</b> purchased (3) horns for material handling applications.
								</p>
							</div>
						</div>
					</div>
					<Divider />
					<AppsAndService />
				</div>
    	</div>
    )
  }
}

AboutPage.propTypes = {}
AboutPage.defaultProps = {}
AboutPage.data = {
  menuLabel: 'About',
  menuShortDescription: 'About for Acoustic Cleaning Services, Inc.'
}
export default AboutPage



// WEBPACK FOOTER //
// ./about.js